export * from './ifta-logs.dto';
